import { useMutation, useQueryClient } from '@tanstack/react-query';
import { createCountry } from 'API/Country/createCountry';

const useCreateCountry = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const create = async (countryData) => {
        const response = await createCountry(countryData);
        return response.data;
    };

    return useMutation({
        mutationFn: create,
        onSuccess: (data) => {
            queryClient.invalidateQueries({ queryKey: ['Countries'] });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useCreateCountry;
